import { ApiService } from "./apiService";


export const getStoreTypes = async () => {
  return await ApiService.get(`lookups/store-types`);
}

// The closed value lists the raw-product identity graphs choose from. A
// reviewer correcting kind, area, audience or form has to pick from the same
// lists, since a value outside them is one no later pass can read - so they are
// fetched from the server rather than copied into the frontend, where they
// would drift from the graphs that are bound to them.
export interface ProductIdentityValues {
  kinds: string[];
  targetAreas: string[];
  targetAudiences: string[];
  targetGenders: string[];
  forms: string[];
  packShapes: string[];
  weightUnits: string[];
}

export const getProductIdentityValues = async (): Promise<ProductIdentityValues> => {
  return await ApiService.get(`lookups/product-identity`);
}

// Codes and names only: the raw product stores an ISO code rather than a
// relation, so the picker shows the name and saves the code.
export interface CountryOption {
  iso: string;
  name: string;
  nameAR: string;
}

export const getCountryCodes = async (): Promise<CountryOption[]> => {
  return await ApiService.get(`lookups/countries`);
}

// Pickers for a store's address, as { label, value } pairs.
export const getGovernorates = async () => {
  return await ApiService.get(`lookups/governorates`);
}

export const getCities = async (governorateId: string) => {
  return await ApiService.get(`lookups/governorates/${governorateId}/cities`);
}
